import $ from 'jquery';
import 'what-input';
import aon_craft_utils from './aon_craft_utils.js';
import aon_craft_onboarding from './aon_craft_onboarding.js';
import aon_craft_calendar from './aon_craft_calendar.js';
import aon_craft_sliders from './aon_craft_sliders.js';
import aon_craft_triangles_circles from './aon_craft_triangles_circles.js';
import aon_craft_step_navigation from './aon_craft_step_navigation.js';
import aon_craft_particles from './aon_craft_particles.js';
import aon_craft_add_person from './aon_craft_add_person.js';
import aon_craft_section_1a from './aon_craft_section_1a.js';
import aon_craft_section_2a from './aon_craft_section_2a.js';
import aon_craft_section_2b from './aon_craft_section_2b.js';
import aon_craft_section_3b from './aon_craft_section_3b.js';
import aon_craft_section_2c from './aon_craft_section_2c.js';
import aon_craft_todos from './aon_craft_todos.js';
import aon_craft_section_3c from './aon_craft_section_3c.js';
import aon_craft_product_randomiser from './aon_craft_product_randomiser.js';
import aon_craft_customer_creator from './aon_craft_customer_creator.js';
import aon_craft_section_4a from './aon_craft_section_4a.js';
import aon_craft_section_4b from './aon_craft_section_4b.js';
import aon_craft_section_5a from './aon_craft_section_5a.js';
import aon_craft_section_5b from './aon_craft_section_5b.js';
import aon_craft_section_5c from './aon_craft_section_5c.js';
import chartist from './chartist.min.js';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

$( document ).foundation();


$( document ).ready( function() {
	
	function getSliderSettings() {
		//console.log( 'Set slider...' );
        // Check if page is RTL...
        var rtl_mode = false;
        if ( $( 'html[dir="rtl"]' ).length > 0 ) {
            rtl_mode = true;
            //console.log( 'RTL = ' + rtl_mode );
        } else {
            //console.log( 'RTL = ' + rtl_mode );
        }
		return {
			infinite: false,
			arrows: true,
			prevArrow: '<button type="button" class="slick-previous"><span class="show-for-sr">Previous Slide</span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next Slide</span></button>',
			autoplay: false,
			fade: false,
			adaptiveHeight: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			rtl: rtl_mode,
			initialSlide: 2,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						initialSlide: 3,
					}
				},
				{
					breakpoint: 600,
					settings: {
						initialSlide: 4,
					}
				},
				{
					breakpoint: 480,
					settings: {
						initialSlide: 4,
					}
				}
			]
		}
	}
	
	if ( !$( '#homepage_sections_slider' ).hasClass( 'slick-initialized' ) ) {
		$( '#homepage_sections_slider' ).slick( getSliderSettings() );
	}
	
	$( '#homepage_sections_slider' ).on( 'afterChange', function( event, slick, currentSlide ) {
		console.log( 'Current slide: ' + currentSlide );
	});
	
	//$( '#homepage_sections_slider' ).on( 'resizeme.zf.trigger', resetSlider );
	function resetSlider() {
		$( '#homepage_sections_slider' ).slick( 'unslick' ).slick( getSliderSettings() );
	}
	
});

// Language Selector
$( 'body' ).on( 'click', '.language_selector input[type="radio"]', function( event ) {
	console.log( 'Language clicked: ' + $( this ).val() );
	var lang_save = $( this ).val();
	if ( lang_save == '' ) {
		lang_save = 'Save';
	}
	$( '.language_selector input[type="submit"]' ).val( $( '.lang_save_' + lang_save ).val() );
	//event.preventDefault();
});

var onboarding_dashboard_modal_2_top = 0;
var onboarding_dashboard_modal_2_left = 0;
var onboarding_dashboard_modal_3_top = 0;
var onboarding_dashboard_modal_3_left = 0;

// Show Onboarding Popups if modal exists (this will be controlled via PHP in the live template)
if ( $( '#onboarding_dashboard_modal_1' ).length > 0 ) {
	console.log( '#onboarding_dashboard_modal_1 exists' );
	$( '#onboarding_dashboard_modal_1' ).foundation( 'open' );
}

$( 'body' ).on( 'click', '#onboarding_dashboard_modal_1 .button', function( event ) {
	$( '#onboarding_dashboard_modal_1' ).foundation( 'close' );
	$( '#onboarding_dashboard_modal_2' ).show();
	Foundation.SmoothScroll.scrollToLoc( '#onboarding_dashboard_modal_2' );
	event.preventDefault();
});

$( 'body' ).on( 'click', '#onboarding_dashboard_modal_2 .button', function( event ) {
	$( '#onboarding_dashboard_modal_3' ).show();
	Foundation.SmoothScroll.scrollToLoc( '#onboarding_dashboard_modal_3' );
	$( '#onboarding_dashboard_modal_2' ).hide();
	event.preventDefault();
});

$( 'body' ).on( 'click', '#onboarding_dashboard_modal_3 .button', function( event ) {
	Foundation.SmoothScroll.scrollToLoc( '#dashboard', '', function() {
		$( '#onboarding_dashboard_modal_4' ).foundation( 'open' );
	});
	$( '#onboarding_dashboard_modal_3' ).hide();
	event.preventDefault();
});


// Onboarding Popups open event...
$( 'body' ).on( 'open.zf.reveal', '#onboarding_dashboard_modal_2', function() {
	
});

// Onboarding Popups closeme event...
$( 'body' ).on( 'closeme.zf.reveal', '.onboarding_dashboard_modal', function() {
	//console.log( 'TARGET POPUP ID: ' + $( this ).attr( 'id' ) );
	if ( $( this ).attr( 'id' ) == 'onboarding_dashboard_modal_2' ) {
		console.log( 'onboarding_dashboard_modal_1 closed' );
		$( '#onboarding_dashboard_modal_2' ).css( 'top', onboarding_dashboard_modal_2_top+'px' ).css( 'left', onboarding_dashboard_modal_2_left+'px' );
	}
	console.log( 'closeme.zf.reveal' );
});

function whichAnimationEvent() {
    var t,
      el = document.createElement( 'fakeelement' );

    var animations = {
        'animation'      : 'animationend',
        'OAnimation'     : 'oAnimationEnd',
        'MozAnimation'   : 'animationend',
        'WebkitAnimation': 'webkitAnimationEnd'
    }

    for ( t in animations ) {
        if ( el.style[t] !== undefined ) {
          return animations[t];
        }
    }
}

var animationEvent = whichAnimationEvent();



$('section .progress_100 .progress__indicator').one(
    animationEvent,
    function( event ) {
        // Do something when the animation ends
        //alert( $( this ).attr( 'class' ) );
        var targ = $( this ).parent().parent();
        //alert( targ.attr( 'class' ) );
        console.log( 'targ: ' + targ.attr( 'class' ) );
        aon_craft_particles.triggerParticles( targ );
    }
);

// Print Button
$( 'body' ).on( 'click', '.print_init', function( event ) {
    window.print();
    event.preventDefault();
});


// Force numeric input only...
$( '.numeric_only' ).keyup( function( event ) {
    var val = $( this ).val();
    if ( isNaN( val ) ) {
         val = val.replace(/[^0-9\.]/g, '' );
         if ( val.split( '.' ).length > 2 ) { 
             val = val.replace(/\.+$/, '' );
         }
    }
    $( this ).val( val.replace( '-', '' ) ); 
});


// Password Show / Hide toggle
$( 'body' ).on( 'click', '.pwd_field_wrap .pwd_toggle', function( event ) {
	if ( $( this ).hasClass( 'show-pwd' ) ) {
		$( '.pwd_field_wrap .pwd_toggle' ).removeClass( 'show-pwd' ).addClass( 'hide-pwd' );
		$( '.pwd_field_wrap input' ).attr( 'type', 'text' );
	} else if ( $( this ).hasClass( 'hide-pwd' ) ) {
		$( '.pwd_field_wrap .pwd_toggle' ).removeClass( 'hide-pwd' ).addClass( 'show-pwd' );
		$( '.pwd_field_wrap input' ).attr( 'type', 'password' );
	}
});

// Mark Onboarding as Completed
$( 'body' ).on( 'click', '.onboarding_completed', function( event ) {
	// Remove class that prevents user interaction when final onboarding modal is closed
	$( 'section' ).removeClass( 'prevent-interaction' );
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'ONBOARDING - MARK AS COMPLETED AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var meta = { 'onboarding_status' : 'yes' };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );

	});
	console.log( 'ONBOARDING - MARK AS COMPLETED AJAX - END' );
});


/* 
 * END OF SECTION QUESTIONS
 */
// End of Section 1 Questions
// Check values are set and enabled save button...
$( '#section_1_end_question_1, #section_1_end_question_2, input[name="section_1_end_question_3_a"], input[name="section_1_end_question_3_b"], input[name="section_1_end_question_3_c"], input[name="section_1_end_question_3_d"], input[name="section_1_end_question_3_e"]' ).on( 'change', function( event ) {
	
	if ( $( '#section_1_end_question_1' ).val() != '' && $( '#section_1_end_question_2' ).val() != '' && $( 'input[name="section_1_end_question_3_a"]' ).is( ':checked' ) && $( 'input[name="section_1_end_question_3_b"]' ).is( ':checked' ) && $( 'input[name="section_1_end_question_3_c"]' ).is( ':checked' ) != '' && $( 'input[name="section_1_end_question_3_d"]' ).is( ':checked' ) && $( 'input[name="section_1_end_question_3_e"]' ).is( ':checked' ) ) {
		$( '#end_questions_section_1 .save_end_questions' ).removeClass( 'disabled' );
	} else {
		$( '#end_questions_section_1 .save_end_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#end_questions_section_1 .save_end_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'END OF SECTION 1 QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var section_1_end_question_1 = $( '#section_1_end_question_1' ).val();
	var section_1_end_question_2 = $( '#section_1_end_question_2' ).val();
	var section_1_end_question_3_a = $( 'input[name="section_1_end_question_3_a"]:checked' ).val();
	var section_1_end_question_3_b = $( 'input[name="section_1_end_question_3_b"]:checked' ).val();
	var section_1_end_question_3_c = $( 'input[name="section_1_end_question_3_c"]:checked' ).val();
	var section_1_end_question_3_d = $( 'input[name="section_1_end_question_3_d"]:checked' ).val();
	var section_1_end_question_3_e = $( 'input[name="section_1_end_question_3_e"]:checked' ).val();
	
	var meta = { 
				'section_1_end_question_1' : section_1_end_question_1, 
				'section_1_end_question_2' : section_1_end_question_2, 
				'section_1_end_question_3_a' : section_1_end_question_3_a, 
				'section_1_end_question_3_b' : section_1_end_question_3_b, 
				'section_1_end_question_3_c' : section_1_end_question_3_c, 
				'section_1_end_question_3_d' : section_1_end_question_3_d, 
				'section_1_end_question_3_e' : section_1_end_question_3_e, 
				'section_1_end_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'END OF SECTION 1 QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});

// End of Section 2 Questions
// Check values are set and enabled save button...
$( '#section_2_end_question_1, #section_2_end_question_2' ).on( 'change', function( event ) {
	
	if ( $( '#section_2_end_question_1' ).val() != '' && $( '#section_2_end_question_2' ).val() != '' ) {
		$( '#end_questions_section_2 .save_end_questions' ).removeClass( 'disabled' );
	} else {
		$( '#end_questions_section_2 .save_end_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#end_questions_section_2 .save_end_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'END OF SECTION 2 QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var section_2_end_question_1 = $( '#section_2_end_question_1' ).val();
	var section_2_end_question_2 = $( '#section_2_end_question_2' ).val();
	
	var meta = { 
				'section_2_end_question_1' : section_2_end_question_1, 
				'section_2_end_question_2' : section_2_end_question_2, 
				'section_2_end_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'END OF SECTION 2 QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});

// End of Section 3 Questions
// Check values are set and enabled save button...
$( '#section_3_end_question_1, #section_3_end_question_2' ).on( 'change', function( event ) {
	
	if ( $( '#section_3_end_question_1' ).val() != '' && $( '#section_3_end_question_2' ).val() != '' ) {
		$( '#end_questions_section_3 .save_end_questions' ).removeClass( 'disabled' );
	} else {
		$( '#end_questions_section_3 .save_end_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#end_questions_section_3 .save_end_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'END OF SECTION 3 QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var section_3_end_question_1 = $( '#section_3_end_question_1' ).val();
	var section_3_end_question_2 = $( '#section_3_end_question_2' ).val();
	
	var meta = { 
				'section_3_end_question_1' : section_3_end_question_1, 
				'section_3_end_question_2' : section_3_end_question_2, 
				'section_3_end_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'END OF SECTION 3 QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});

// End of Section 4 Questions
// Check values are set and enabled save button...
$( '#section_4_end_question_1, #section_4_end_question_2' ).on( 'change', function( event ) {
	
	if ( $( '#section_4_end_question_1' ).val() != '' && $( '#section_4_end_question_2' ).val() != '' ) {
		$( '#end_questions_section_4 .save_end_questions' ).removeClass( 'disabled' );
	} else {
		$( '#end_questions_section_4 .save_end_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#end_questions_section_4 .save_end_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'END OF SECTION 4 QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var section_4_end_question_1 = $( '#section_4_end_question_1' ).val();
	var section_4_end_question_2 = $( '#section_4_end_question_2' ).val();
	
	var meta = { 
				'section_4_end_question_1' : section_4_end_question_1, 
				'section_4_end_question_2' : section_4_end_question_2, 
				'section_4_end_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'END OF SECTION 4 QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});

// End of Section 5 Questions
// Check values are set and enabled save button...
$( '#section_5_end_question_1, input[name="section_5_end_question_2_a"], input[name="section_5_end_question_2_b"], input[name="section_5_end_question_2_c"], #section_5_end_question_3' ).on( 'change', function( event ) {
	
	if ( $( '#section_5_end_question_1' ).val() != '' && $( 'input[name="section_5_end_question_2_a"]' ).is( ':checked' ) && $( 'input[name="section_5_end_question_2_b"]' ).is( ':checked' ) && $( 'input[name="section_5_end_question_2_c"]' ).is( ':checked' ) != '' && $( '#section_5_end_question_3' ).val() != ''  ) {
		$( '#end_questions_section_5 .save_end_questions' ).removeClass( 'disabled' );
	} else {
		$( '#end_questions_section_5 .save_end_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#end_questions_section_5 .save_end_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'END OF SECTION 5 QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var section_5_end_question_1 = $( '#section_5_end_question_1' ).val();
	var section_5_end_question_2_a = $( 'input[name="section_5_end_question_2_a"]:checked' ).val();
	var section_5_end_question_2_b = $( 'input[name="section_5_end_question_2_b"]:checked' ).val();
	var section_5_end_question_2_c = $( 'input[name="section_5_end_question_2_c"]:checked' ).val();
	var section_5_end_question_3 = $( '#section_5_end_question_3' ).val();
	
	var meta = { 
				'section_5_end_question_1' : section_5_end_question_1, 
				'section_5_end_question_2_a' : section_5_end_question_2_a, 
				'section_5_end_question_2_b' : section_5_end_question_2_b, 
				'section_5_end_question_2_c' : section_5_end_question_2_c, 
				'section_5_end_question_3' : section_5_end_question_3, 
				'section_5_end_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'END OF SECTION 5 QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});


// All Sections Completed Questions
// Check values are set and enabled save button...
$( '#sections_all_completed_end_question_1, #sections_all_completed_end_question_2, #sections_all_completed_end_question_3, #sections_all_completed_end_question_4, #sections_all_completed_end_question_5, #sections_all_completed_end_question_6' ).on( 'change', function( event ) {
//$( '#sections_all_completed_end_question_1, #sections_all_completed_end_question_2, #sections_all_completed_end_question_3, #sections_all_completed_end_question_4, #sections_all_completed_end_question_5, #sections_all_completed_end_question_6, #sections_all_completed_end_question_7' ).on( 'change', function( event ) {
	
	// If all question fields have a value...
	if ( $( '#sections_all_completed_end_question_1' ).val() != '' && $( '#sections_all_completed_end_question_2' ).val() != '' && $( '#sections_all_completed_end_question_3' ).val() != '' && $( '#sections_all_completed_end_question_4' ).val() != '' && $( '#sections_all_completed_end_question_5' ).val() != '' && $( '#sections_all_completed_end_question_6' ).val() != '' && $( '#sections_all_completed_end_question_7' ).val() != '' ) {
		
		/*// If Q7 is `yes` then make sure the email field is enabled...
		if ( $( '#sections_all_completed_end_question_7' ).val() == 'yes' ) {
			$( '#sections_all_completed_end_question_7_email' ).removeAttr( 'disabled' );
		} else { // If Q7 is `no` then disable and empty email field...
			$( '#sections_all_completed_end_question_7_email' ).attr( 'disabled', 'disabled' ).val( '' );
		}*/
		
		//if ( $( '#sections_all_completed_end_question_7' ).val() == 'yes' ) {
		//	// Check if email is filled and valid
		//	checkAllSectionsEmailValid();
		//} else {
			$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).removeClass( 'disabled' );
		//}
		
	} else {
		$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

function isValidEmail( email ) {
	var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
	return regex.test( email );
}

function checkAllSectionsEmailValid() {	
	console.log( 'Email valid: ' + isValidEmail( $( '#sections_all_completed_end_question_7_email' ).val() ) );
	if ( $( '#sections_all_completed_end_question_7_email' ).val() != '' && isValidEmail( $( '#sections_all_completed_end_question_7_email' ).val() ) ) {
		$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).removeClass( 'disabled' );
	} else {
		$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).addClass( 'disabled' );
	}
}

$( '#sections_all_completed_end_question_7_email' ).on( 'keyup', function( event ) {
	console.log( 'Email valid: ' + isValidEmail( $( '#sections_all_completed_end_question_7_email' ).val() ) );
	// If Q7 is yes...
	if ( $( this ).val() != '' && isValidEmail( $( this ).val() ) && $( '#sections_all_completed_end_question_1' ).val() != '' && $( '#sections_all_completed_end_question_2' ).val() != '' && $( '#sections_all_completed_end_question_3' ).val() != '' && $( '#sections_all_completed_end_question_4' ).val() != '' && $( '#sections_all_completed_end_question_5' ).val() != '' && $( '#sections_all_completed_end_question_6' ).val() != '' && $( '#sections_all_completed_end_question_7' ).val() != '' ) {
		$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).removeClass( 'disabled' );
	} else {
		$( '#sections_all_completed_questions .save_all_sections_completed_questions' ).addClass( 'disabled' );
	}
	
	event.preventDefault();
});

$( 'body' ).on( 'click', '#sections_all_completed_questions .save_all_sections_completed_questions', function( event ) {
	// Call AJAX request to WP / Rest API
	// Save completed data to backend...
	console.log( 'ALL SECTIONS COMPLETED QUESTIONS - AJAX - START' );
	//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
	var sections_all_completed_end_question_1 = $( '#sections_all_completed_end_question_1' ).val();
	var sections_all_completed_end_question_2 = $( '#sections_all_completed_end_question_2' ).val();
	var sections_all_completed_end_question_3 = $( '#sections_all_completed_end_question_3' ).val();
	var sections_all_completed_end_question_4 = $( '#sections_all_completed_end_question_4' ).val();
	var sections_all_completed_end_question_5 = $( '#sections_all_completed_end_question_5' ).val();
	var sections_all_completed_end_question_6 = $( '#sections_all_completed_end_question_6' ).val();
	var sections_all_completed_end_question_7 = $( '#sections_all_completed_end_question_7' ).val();
	var sections_all_completed_end_question_7_email = $( '#sections_all_completed_end_question_7_email' ).val();
	
	var meta = { 
				'sections_all_completed_end_question_1' : sections_all_completed_end_question_1, 
				'sections_all_completed_end_question_2' : sections_all_completed_end_question_2, 
				'sections_all_completed_end_question_3' : sections_all_completed_end_question_3, 
				'sections_all_completed_end_question_4' : sections_all_completed_end_question_4, 
				'sections_all_completed_end_question_5' : sections_all_completed_end_question_5, 
				'sections_all_completed_end_question_6' : sections_all_completed_end_question_6, 
				'sections_all_completed_end_question_7' : sections_all_completed_end_question_7, 
				'sections_all_completed_end_question_7_email' : sections_all_completed_end_question_7_email, 
				'sections_all_completed_questions_status' : 'yes' 
			   };
	$.ajax({
		url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
		method: 'POST',
		beforeSend: function ( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
		},
		data: {
			'meta' : meta
		}
	}).done( function ( response ) {
		console.log( 'Response: ' );
		console.log( response );
		$( location ).attr( 'href', '/' );
		
	}).fail( function ( xhr, status, error ) {
		console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
		$( location ).attr( 'href', '/' );

	});
	console.log( 'ALL SECTIONS COMPLETED QUESTIONS - AJAX - END' );
	
	event.preventDefault();
});


/* 
 * TRIGGER SPIN ANIMATION ON REVEAL 'X' CLOSE BUTTON
 */
$( '[data-reveal]' ).on( 'open.zf.reveal', function() {
	var modal_id = $( this ).attr( 'id' );
	$( '.reveal#' + modal_id + ' .close-button' ).addClass( 'spin' );
});
$( '[data-reveal]' ).on( 'closed.zf.reveal', function() {
	//var modal = $( this );
	$( '.reveal .close-button' ).removeClass( 'spin' );
});



// User Guide Popup close event...
$( 'body' ).on( 'open.zf.reveal', '#userguides_modal', function() {
	console.log( 'open #userguides_modal' );
	var st = $( '#userguides_modal .row' ).scrollTop();
	console.log( 'st: ' + st );
	$('#userguides_modal .row').animate({
        scrollTop: 0
    }, 0);
	
	
});


/* 
 * WARN WHEN RESTARTING A SECTION
 */
/*$( 'body' ).on( 'click', '.progress li.completed a, .callout.completed a, .button.warn_next', function( event ) {
    var url = $( this ).attr( 'href' );
    $( 'a.continue' ).attr( 'href', url );
    $( '#section_restart_warning_modal' ).foundation( 'open' );
    event.preventDefault();
});*/

$( '.progress li.disabled a' ).attr( 'href', '#' );
$( 'body' ).on( 'click', '.progress li.disabled a', function( event ) {
    //var url = $( this ).attr( 'href' );
    //$( 'a.continue' ).attr( 'href', '#' );
    //$( '#section_restart_warning_modal' ).foundation( 'open' );
    event.preventDefault();
});

// Init Step Navigation...
aon_craft_step_navigation.init();